module.exports = __webpack_public_path__ + "img/public-icon.5490cb6b.svg";